module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "row-box"
  }, [_c('div', {
    staticClass: "row-left"
  }, _vm._l((_vm.columnList), function(label) {
    return _c('div', {
      key: label.index,
      class: _vm.active == label.index ? 'left-li left-li-active' : 'left-li',
      on: {
        "click": function($event) {
          return _vm.onSelectLeft(label)
        }
      }
    }, [_vm._v(_vm._s(label.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row-right"
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id }}"
      }],
      key: i,
      staticClass: "right-li flex-start"
    }, [_c('div', {
      staticClass: "right-li-img"
    }, [_c('img', {
      attrs: {
        "src": row.pic_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-li-user"
    }, [_c('div', {
      staticClass: "right-user-one"
    }, [_c('div', {
      staticClass: "right-user-label"
    }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.title))])]), _vm._v(" "), _c('div', {
      staticClass: "right-user-one"
    }, [_c('div', {
      staticClass: "right-user-label"
    }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.desc))])])])])
  }), 0)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88bda4cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Hangyejinying.vue
// module id = 2535
// module chunks = 0